import { useClerk } from "@clerk/clerk-react";
import { useEffect } from "react";
import { track } from "@/lib/analytics";
import {
	type ClerkSignUpResources,
	snapshotFromClerkResources,
	trackCompletedSignUpOnce,
} from "@/lib/signUpAnalytics";

type ClerkListener = {
	addListener: (
		listener: (resources: ClerkSignUpResources) => void,
	) => () => void;
};

/**
 * Fire GA4 `sign_up` once on actual completed trial cadastro.
 *
 * Mounted under `ClerkProvider` so the listener is alive through the redirect
 * off `/sign-up`. Clerk's SignUp `status === "complete"` is sufficient but not
 * required: the live email_code path often finishes via session / SignIn and
 * clears SignUp before that status is observed. Attempt-mark + first signed-in
 * hop covers that path (see `signUpAnalytics.ts`).
 */
export function useTrackCompletedSignUp(): void {
	const clerk = useClerk() as unknown as ClerkListener;

	useEffect(() => {
		return clerk.addListener((resources) => {
			try {
				trackCompletedSignUpOnce(
					snapshotFromClerkResources(resources, window.location.pathname),
					{
						track,
						storage: window.sessionStorage,
					},
				);
			} catch {
				// Analytics must never break the sign-up path.
			}
		});
	}, [clerk]);
}

export function SignUpAnalytics(): null {
	useTrackCompletedSignUp();
	return null;
}
